import styled from 'styled-components';
export const InputContainer = styled.div `
  position: sticky;
  bottom: 0;
  width: 100%;
  flex-shrink: 0;
  margin-top: auto;
`;
